/*
===============================================================================================================
                                 Copyright 2025-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import SimpleButton from '@/components/button-simple';
import useInactiveSession from '@/utilities/useInactiveSession';
import React, { useContext } from 'react';
import WarningTriangle from '@/public/icons/warning-triangle.svg';
import TextDiv from '@/components/text-div';
import { LocaleContext } from '@/contexts/locale-context';

// eslint-disable-next-line react/prop-types
export default function IdleBannerLayout({ children }) {
  const {
    isPromptVisible, countdown, dismissPrompt,
  } = useInactiveSession();
  const { translate } = useContext(LocaleContext);
  return (
    <>
      <>{children}</>
      <div className={`idle-banner ${isPromptVisible ? 'visible' : ''}`}>
        <div className="idle-banner-content">
          <WarningTriangle />
          <div className="idle-banner-text">
            <TextDiv>{translate('constants.idleBanner.title')}</TextDiv>
            <TextDiv>
              {translate('constants.idleBanner.text', { countdown })}
            </TextDiv>
          </div>
        </div>
        <div className="idle-banner-actions">
          <SimpleButton onClick={dismissPrompt} isLozenge>
            {translate('constants.dismiss')}
          </SimpleButton>
        </div>
      </div>

      <style jsx>
        {`
        .idle-banner {
          width: 373px;
          position: fixed;
          border-radius: var(--border-radius);
          box-shadow: var(--box-shadow);
          border: 1px solid var(--color-line-grey);
          bottom: 32px;
          right: 32px;
          background-color: var(--color-white);
          padding: 24px 32px;
          z-index: 1000;
          opacity: 0.2;
          transition: all 0.3s ease-in-out;
          transform: translateX(120%);
        }

        .idle-banner-text {
          display: flex;
          flex-direction: column;
          gap: 8px;
          font-weight: bold;
          font-size: var(--font-size-H3);
          text-wrap: no-wrap;
        }

        .idle-banner-actions {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .visible {
          transform: translateX(0);
          opacity: 1;
        }

        .idle-banner-content {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        @media (max-width: 768px) {
          .idle-banner {
            width: calc(100% - 64px);
            right: 32px;
            left: 32px;
            bottom: 16px;
          }
      `}
      </style>
    </>
  );
}
